export default (timelineValues: number[] | string[]): boolean => timelineValues?.length < 120;
